/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * Audius V1 API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Comment } from './Comment';
import {
    CommentFromJSON,
    CommentFromJSONTyped,
    CommentToJSON,
} from './Comment';

/**
 * 
 * @export
 * @interface TrackCommentsResponse
 */
export interface TrackCommentsResponse {
    /**
     * 
     * @type {Array<Comment>}
     * @memberof TrackCommentsResponse
     */
    data?: Array<Comment>;
}

/**
 * Check if a given object implements the TrackCommentsResponse interface.
 */
export function instanceOfTrackCommentsResponse(value: object): value is TrackCommentsResponse {
    let isInstance = true;

    return isInstance;
}

export function TrackCommentsResponseFromJSON(json: any): TrackCommentsResponse {
    return TrackCommentsResponseFromJSONTyped(json, false);
}

export function TrackCommentsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackCommentsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(CommentFromJSON)),
    };
}

export function TrackCommentsResponseToJSON(value?: TrackCommentsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(CommentToJSON)),
    };
}

